import { render, staticRenderFns } from "./AppointmentCheckStatus.vue?vue&type=template&id=f09fec66&"
import script from "./AppointmentCheckStatus.vue?vue&type=script&lang=ts&"
export * from "./AppointmentCheckStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports